import {useQuery} from "@tanstack/react-query";

import type {ParamsOptions} from "@/src/modules/core/types";

import {companyVehiclesService} from "../services";

type UseCompanyVehicleOptions = ParamsOptions & {
  /** When false, skips the query even if `id` is set. Default true. */
  enabled?: boolean;
};

export function useCompanyVehicle(
  id: number | null,
  options?: UseCompanyVehicleOptions,
) {
  const can = companyVehiclesService.getCanShowCompanyVehicle();
  const {enabled: enabledOption = true, ...params} = options ?? {};
  const query = useQuery({
    queryKey: ["company-vehicles", id, params],
    queryFn: () => companyVehiclesService.getCompanyVehicleById(id!, params),
    enabled: can && id != null && id > 0 && enabledOption,
  });

  return {
    ...query,
    vehicle: query.isSuccess && id != null && id > 0 ? query.data ?? null : null,
  };
}
